/* ============================================================
   Tafra — components.js
   Behaviour for the shared chrome. The header, footer, mobile
   drawer and the product-request modal are rendered server-side by
   the Blade partials in resources/views/website/layouts/components,
   so this file only wires them up.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- header scroll state ---------------------------------
  var header = document.getElementById('siteHeader');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- drawer ----------------------------------------------
  var drawer = document.getElementById('drawer');
  var drawerTimer;

  function openDrawer() {
    if (!drawer) return;
    clearTimeout(drawerTimer);
    drawer.hidden = false;
    // force reflow so the panel animates in from its start position
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    clearTimeout(drawerTimer);
    if (reduceMotion) { drawer.hidden = true; return; }
    // keep the drawer in the DOM until the slide-out finishes
    drawerTimer = setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 360);
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
  }


  // ---- product request modal -------------------------------
  /* One modal serves every [data-request] button on the page: the button hands
     over the product it stands for, and the form posts without leaving the page
     so the visitor keeps their place in the listing. */
  var modal = document.getElementById('requestModal');
  var modalForm = modal && modal.querySelector('[data-modal-form]');
  var modalSuccess = modal && modal.querySelector('[data-modal-success]');
  var modalLabel = modal && modal.querySelector('[data-modal-product]');
  var modalProductId = modal && modal.querySelector('[data-modal-product-id]');
  var modalError = modal && modal.querySelector('[data-modal-error]');
  var modalSubmit = modal && modal.querySelector('[data-modal-submit]');
  var modalSpinner = modal && modal.querySelector('[data-modal-spinner]');
  var defaultModalLabel = modalLabel ? modalLabel.textContent : '';
  var modalTimer;

  function openModal(trigger) {
    if (!modal) return;
    clearTimeout(modalTimer);

    modalLabel.textContent = trigger.getAttribute('data-product-name') || defaultModalLabel;
    modalProductId.value = trigger.getAttribute('data-product-id') || '';

    modalForm.hidden = false;
    modalSuccess.hidden = true;
    if (modalError) { modalError.hidden = true; modalError.textContent = ''; }

    modal.hidden = false;
    // force a reflow so the dialog animates in from its start state
    void modal.offsetWidth;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeDrawer();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    clearTimeout(modalTimer);
    if (reduceMotion) { modal.hidden = true; return; }
    // keep it mounted until the exit animation finishes
    modalTimer = setTimeout(function () {
      if (!modal.classList.contains('is-open')) modal.hidden = true;
    }, 380);
  }

  function releaseModal() {
    modalSubmit.disabled = false;
    modalSubmit.classList.remove('is-loading');
    if (modalSpinner) modalSpinner.hidden = true;
  }

  if (modal) {
    // close on backdrop click (only the overlay, not the dialog)
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

    modalForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (modalSubmit.disabled) return;

      modalSubmit.disabled = true;
      modalSubmit.classList.add('is-loading');
      if (modalSpinner) modalSpinner.hidden = false;
      if (modalError) modalError.hidden = true;

      fetch(modalForm.action, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(modalForm)
      }).then(function (response) {
        return response.json().then(function (body) { return { ok: response.ok, body: body }; });
      }).then(function (result) {
        if (result.ok) {
          modalForm.hidden = true;
          modalSuccess.hidden = false;
          modalForm.reset();
          if (window.turnstile) window.turnstile.reset();
          return;
        }
        // Laravel answers 422 with {errors: {field: [messages]}}
        var errors = result.body && result.body.errors;
        var first = errors && errors[Object.keys(errors)[0]];
        showModalError(first && first[0] ? first[0] : (result.body && result.body.message));
      }).catch(function () {
        showModalError(null);
      }).then(releaseModal);
    });
  }

  function showModalError(message) {
    if (!modalError) return;
    modalError.textContent = message || 'Something went wrong. Please try again.';
    modalError.hidden = false;
    if (window.turnstile) window.turnstile.reset();
  }

  // ---- global click delegation -----------------------------
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-request],[data-drawer-open],[data-drawer-close],[data-modal-close]');
    if (!t) return;
    if (t.hasAttribute('data-request'))           openModal(t);
    else if (t.hasAttribute('data-drawer-open'))  openDrawer();
    else if (t.hasAttribute('data-drawer-close')) closeDrawer();
    else                                          closeModal();
  });

  // ---- escape key ------------------------------------------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (modal && !modal.hidden) closeModal();
    else if (drawer && !drawer.hidden) closeDrawer();
  });
})();
